import script from "./NavigationBurger.vue?vue&type=script&setup=true&lang=ts"
export * from "./NavigationBurger.vue?vue&type=script&setup=true&lang=ts"

import "./NavigationBurger.vue?vue&type=style&index=0&id=810a6dee&lang=scss"

const __exports__ = script;

export default __exports__